<script setup>
// 格式信息页路由 /format/<slug>（type-2 纯 SSR，nuxt#8）。
import { getFormatSEO } from "@/settings/free-tools/format-seo";
import "@/assets/styles/free-tools.css";

definePageMeta({ layout: "free-tools" });

const route = useRoute();
const slug = computed(() => String(route.params.slug || "").toLowerCase());

const { data: seo } = await useAsyncData(
  () => "format-" + slug.value,
  () => getFormatSEO(slug.value) ?? null,
  { watch: [slug], default: () => null }
);

if (!seo.value) {
  throw showError({ statusCode: 404, statusMessage: "Format not found" });
}

useHead(() => ({
  title: seo.value.title,
  meta: [
    { name: "description", content: seo.value.desc },
    { property: "og:title", content: seo.value.title },
    { property: "og:description", content: seo.value.desc },
    { property: "og:url", content: seo.value.url },
    { property: "og:type", content: "article" },
    { name: "twitter:card", content: "summary_large_image" },
  ],
  link: [{ rel: "canonical", href: seo.value.canonical }],
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify([
        { "@context": "https://schema.org", "@type": "Article", headline: `What is a ${seo.value.ext} file?`, description: seo.value.what, about: seo.value.full },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: seo.value.crumb.map((c, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: c[0],
            item: String(c[1]).startsWith("http") ? c[1] : "https://sharkfoto.com" + c[1],
          })),
        },
      ]),
    },
  ],
}));
</script>

<template>
  <FormatInfoPage v-if="seo" :seo="seo" />
</template>
